const CAROUSEL_ITEMS = [
  {
    img: 'https://readdy.ai/api/search-image?query=A%20stunning%20wide%20banner%20style%20manga%20illustration%20with%20dramatic%20composition%2C%20epic%20fantasy%20landscape%20with%20floating%20islands%2C%20warm%20sunset%20colors%2C%20silhouette%20of%20adventurers%2C%20Japanese%20anime%20style%20background%20art%2C%20cinematic%20lighting%2C%20soft%20gradients&width=1200&height=500&seq=carousel-banner-01&orientation=landscape',
    tag: '本周必看',
    title: '【独家】2026 夏季新番速递：这些韩漫改编动画你不能错过',
    desc: '多部人气韩漫 IP 确认动画化，从奇幻冒险到都市纯爱，今年夏天的追番列表已经排满了。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20ancient%20style%20wide%20banner%20illustration%20with%20traditional%20palace%20architecture%2C%20flowing%20silk%20robes%2C%20cherry%20trees%2C%20warm%20golden%20hour%20lighting%2C%20ink%20wash%20painting%20influence%2C%20ethereal%20and%20elegant%20atmosphere&width=1200&height=500&seq=carousel-banner-02&orientation=landscape',
    tag: '国漫新生',
    title: '国产漫画迎来爆发期：五大现象级国漫作品赏析',
    desc: '从古风仙侠到现代都市，近年来国漫在画风和叙事上取得长足进步，这些作品值得每一个漫迷关注。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Wide%20banner%20illustration%20of%20suspenseful%20noir%20detective%20scene%20in%20manga%20style%2C%20rainy%20city%20street%20at%20night%2C%20warm%20street%20lamp%20glow%2C%20dramatic%20shadows%2C%20mystery%20atmosphere%2C%20film%20noir%20inspired%20composition&width=1200&height=500&seq=carousel-banner-03&orientation=landscape',
    tag: '悬疑特辑',
    title: '烧脑预警：悬疑分类中那些让人彻夜难眠的神作',
    desc: '从韩漫心理悬疑到日漫本格推理，一次性整理悬疑分类中最值得熬夜追完的精品漫画清单。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Warm%20and%20cozy%20wide%20illustration%20of%20manga%20reading%20nook%20with%20bookshelves%2C%20comfortable%20chair%2C%20warm%20lamp%20light%2C%20plants%2C%20comic%20books%20displayed%2C%20soft%20cream%20and%20coral%20color%20palette%2C%20inviting%20atmosphere&width=1200&height=500&seq=carousel-banner-04&orientation=landscape',
    tag: '阅读指南',
    title: '新新漫画阅读指南：从零开始搭建你的专属书架',
    desc: '教你如何利用分类筛选、收藏管理和更新提醒功能，在新新漫画上打造最高效的追更体验。',
  },
  {
    img: 'https://readdy.ai/api/search-image?query=Exciting%20wide%20banner%20of%20manga%20award%20ceremony%20concept%20illustration%2C%20spotlight%20on%20stage%2C%20golden%20trophy%2C%20celebration%20atmosphere%2C%20warm%20festive%20lighting%2C%20elegant%20design%2C%20prestigious%20feel&width=1200&height=500&seq=carousel-banner-05&orientation=landscape',
    tag: '年度榜单',
    title: '2026 上半年最受欢迎漫画 Top 10 年度盘点',
    desc: '综合阅读量、收藏数和漫友讨论度，为你揭晓 2026 上半年最具影响力的十部漫画作品。',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="mx-auto max-w-[1280px] px-4 md:px-6">
        <h2 className="text-[22px] md:text-[28px] font-heading font-bold text-foreground-950 text-center mb-3">
          编辑精选
        </h2>
        <p className="text-[14px] text-foreground-500 text-center mb-10">
          编辑团队精心挑选的专题内容，发现更多漫画精彩
        </p>
        <div className="space-y-4 md:space-y-5">
          {CAROUSEL_ITEMS.map((item) => (
            <div
              key={item.title}
              className="group flex flex-col md:flex-row bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all cursor-pointer"
            >
              <div className="md:w-[400px] lg:w-[480px] h-[220px] md:h-[240px] flex-shrink-0 overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="flex-1 p-5 md:p-6 flex flex-col justify-center">
                <span className="inline-block self-start px-3 py-1 rounded-full bg-accent-100 text-accent-700 text-[12px] font-bold mb-3">
                  {item.tag}
                </span>
                <h3 className="text-[17px] md:text-[19px] font-bold text-foreground-900 mb-2 group-hover:text-primary-500 transition-colors">
                  {item.title}
                </h3>
                <p className="text-[14px] leading-relaxed text-foreground-600">{item.desc}</p>
                <span className="inline-flex items-center gap-1 mt-3 text-[13px] font-semibold text-primary-500">
                  阅读更多 <i className="ri-arrow-right-line"></i>
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}